import {ModuleConfiguration} from "../router/model/UserPermission";
import {CustomerSubscriptionModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";


export const CustomerSubscriptionModuleConfiguration = new ModuleConfiguration(
    CustomerSubscriptionModuleName, [AngularJsMaterialModuleName]
);